import { apiRequest } from './apiClient';

export const getDepositsByService = async (serviceId) => {
  return apiRequest(`/deposits/service/${serviceId}`);
};

export const createDepositForService = async (serviceId, depositData) => {
  return apiRequest(`/deposits/service/${serviceId}`, {
    method: 'POST',
    body: depositData,
    modelLabel: 'depósito',
  });
};

export const updateDeposit = async (id, depositData) => {
  return apiRequest(`/deposits/${id}`, { method: 'PUT', body: depositData, modelLabel: 'depósito' });
};

export const deleteDeposit = async (id) => {
  return apiRequest(`/deposits/${id}`, { method: 'DELETE', modelLabel: 'depósito' });
};

